import { Fragment, ReactNode } from "react";
import cx from "classnames";

import DropdownMenuDivider from "ds/components/DropdownMenu/Divider";
import { MainNavigationGroupItem, MainNavigationMenuItem } from "components/MainNavigation/types";
import useMainNavigationActiveStates from "components/MainNavigation/hooks/useActiveStates";
import DropdownMenuSectionHeader from "ds/components/DropdownMenu/Section/Header";
import DropdownMenuSection from "ds/components/DropdownMenu/Section";

import MainNavigationDropdownMenuItem from "../DropdownMenu/Item";
import styles from "./styles.module.css";

export type MainNavigationDropdownMenuItemsCustomRendererProps = {
  key: string;
  item: MainNavigationMenuItem;
  closeDropdown: () => void;
};

export type MainNavigationDropdownMenuItemsProps = {
  group: MainNavigationGroupItem;
  closeDropdown: () => void;
  className?: string;
  customRenderers?: Record<
    string,
    (props: MainNavigationDropdownMenuItemsCustomRendererProps) => ReactNode
  >;
  withGroupTitle?: boolean;
};

const MainNavigationDropdownMenuItems = ({
  group,
  closeDropdown,
  className,
  customRenderers,
  withGroupTitle,
}: MainNavigationDropdownMenuItemsProps) => {
  const { activeMenuItemId } = useMainNavigationActiveStates();

  return (
    <>
      {withGroupTitle && (
        <DropdownMenuSection className={cx(styles.section, styles.groupTitle)}>
          <DropdownMenuSectionHeader>{group.title}</DropdownMenuSectionHeader>
        </DropdownMenuSection>
      )}
      {group.items.map((section, index) => {
        return (
          <Fragment key={section.title || index}>
            {index > 0 && <DropdownMenuDivider />}
            <DropdownMenuSection className={styles.section} key={section.title}>
              {section.title && (
                <DropdownMenuSectionHeader>{section.title}</DropdownMenuSectionHeader>
              )}
              {section.items.map((item) => {
                const customRenderer = customRenderers?.[item.id];
                if (customRenderer) {
                  return customRenderer({ key: item.id, item, closeDropdown });
                }

                return (
                  <MainNavigationDropdownMenuItem
                    key={item.id}
                    item={item}
                    onCloseDropdown={closeDropdown}
                    active={activeMenuItemId === item.id}
                    className={className}
                  >
                    {item.title}
                  </MainNavigationDropdownMenuItem>
                );
              })}
            </DropdownMenuSection>
          </Fragment>
        );
      })}
    </>
  );
};

export default MainNavigationDropdownMenuItems;
